export const FETCH_ALLOCATIONS = 'FETCH_ALLOCATIONS'
export const RECEIVE_ALLOCATIONS = 'RECEIVE_ALLOCATIONS'

export const FETCH_LUCKY_ALLOCATIONS = 'FETCH_LUCKY_ALLOCATIONS'
export const RECEIVE_LUCKY_ALLOCATIONS = 'RECEIVE_LUCKY_ALLOCATIONS'

export const FETCH_RELIGIONS = 'FETCH_RELIGIONS'
export const RECEIVE_RELIGIONS = 'RECEIVE_RELIGIONS'

export const FETCH_STATES = 'FETCH_STATES'
export const RECEIVE_STATES = 'RECEIVE_STATES'

export const FETCH_POLITICAL_AFFILIATIONS = 'FETCH_POLITICAL_AFFILIATIONS'
export const RECEIVE_POLITICAL_AFFILIATIONS = 'RECEIVE_POLITICAL_AFFILIATIONS'

export const FETCH_ETHNICITIES = 'FETCH_ETHNICITIES'
export const RECEIVE_ETHNICITIES = 'RECEIVE_ETHNICITIES'

export const FETCH_SETTINGS = 'FETCH_SETTINGS'
export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS'

export const FETCH_STATS = 'FETCH_STATS'
export const RECEIVE_STATS = 'RECEIVE_STATS'

export const FETCH_USERDATA = 'FETCH_USERDATA'
export const RECEIVE_USERDATA = 'RECEIVE_USERDATA'

export const LOGIN = 'LOGIN'
export const RECEIVE_TOKEN = 'RECEIVE_TOKEN'
export const RESET = 'RESET'



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js